var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFaqizhe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.594 8.983C11.908 8.983 14 10.12 14 11.5c0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.925.621-1.56 2.415-1.993M7.294 12L6.196 8.823m0 0L4 2.468c.784-.353 2.73-.847 4.235 0 1.506.847 3.138.353 3.765 0C12 3.5 11.5 5.5 9 6c-1.892.378-2.752 2.117-2.804 2.823z",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_faqizhe.a60b2a77.svg";
export { SvgTongyongFaqizhe as ReactComponent };